import { apiAgiOperador, apiCallCenterOperador, apiPesquisaSatisfacao, apiClientGeralOperador } from '@/plugins/axios'

export default {
  clickToCallMethod(data) {
    return apiAgiOperador().post('/click-to-call/operador', data)
  },

  getPausasOperador() {
    return apiCallCenterOperador().get('/agent/pausa/lazy')
  },

  acoesOperador(data) {
    return apiCallCenterOperador().post('/agent/login', data)
  },

  verificaLogin(codigoOperador) {
    return apiCallCenterOperador().get(`/agent/login/status/${codigoOperador}`)
  },

  getFilas() {
    return apiPesquisaSatisfacao().get('/queue')
  },

  getOperadoresMonitor(numero) {
    return apiCallCenterOperador().get(`/agent/operador/${numero}`)
  },

  getRamaisApi() {
    return apiClientGeralOperador().get('/ramais/lazy')
  },

}
